import { Molecule, Wrapper } from "AppReact";
import styled from "styled-components";
import { Icon, PrimaryTextSm, RedTextSm } from "atoms";
import {
  CopyOutlineSvg,
  GreenTickSvg,
  LoadingDotsSvg,
  ErrorSvg,
} from "components/icons";
import { Popup } from "./../../atoms";

const template = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;

  position: relative;
  &:hover {
    span {
      display: unset;
    }
  }
`;

const PopupWrapperTemplate = styled.div`
      span {
      display: none;
    }
`;

const PopupWrapper = Wrapper(PopupWrapperTemplate);

export default Molecule({
  template,
  type: "button",
  atoms: [
    {
      component: Icon,
      name: "Icon",
      displayValue: ({ linkCopied, isLoading, isError, isProcessing }) => {
        if (isError) {
          return ErrorSvg({});
        }

        if (isLoading || isProcessing) {
          return LoadingDotsSvg({
            color: window?.settings?.primary_color ?? "#1DBD6B",
          });
        }

        if (linkCopied) {
          return GreenTickSvg({});
        }

        return CopyOutlineSvg({
          width: 14,
          height: 14,
          color: window?.settings?.primary_color ?? "#1DBD6B",
        });
      },
    },
    {
      wrapper: PopupWrapper,
      name: "PopupWrapper",
      atoms: [
        {
          component: Popup,
          name: "Label",
          displayState: () => ({ whiteSpace: 'unset', minWidth: '50px', direction: "right" }),
          renderIf: ({ label, isLoading, isError, isProcessing }) =>
            !!label && !isLoading && !isProcessing && !isError,
          displayValue: ({ label, linkCopiedStateText, linkCopied }) =>
            linkCopied ? linkCopiedStateText : label,
        },
        {
          component: Popup,
          name: "Label",
          displayState: () => ({ whiteSpace: 'unset', minWidth: '50px', direction: "right" }),
          renderIf: ({ label, isLoading }) => isLoading && !!label,
          displayValue: ({ label }) => label,
        },
        {
          component: Popup,
          name: "Label",
          displayState: () => ({ whiteSpace: 'unset', minWidth: '50px', direction: "right" }),
          renderIf: ({ label, isProcessing }) => isProcessing && !!label,
          displayValue: ({ label }) => label,
        },
        {
          component: Popup,
          name: "Label",
          displayState: () => ({ whiteSpace: 'unset', minWidth: '50px', direction: "right" }),
          renderIf: ({ label, isError }) => isError && !!label,
          displayValue: ({ label }) => label,
        },
      ],
    },
  ],
});
